import { render, staticRenderFns } from "./LoginInfo.vue?vue&type=template&id=71560206&scoped=true"
import script from "./LoginInfo.vue?vue&type=script&lang=ts"
export * from "./LoginInfo.vue?vue&type=script&lang=ts"
import style0 from "./LoginInfo.vue?vue&type=style&index=0&id=71560206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71560206",
  null
  
)

export default component.exports